import { ModalComponent } from "../../../../components/modal";
import { Button } from "@mui/material";

interface Props {
    open: boolean;
    onClose: () => void;
}

export const ModalNotAllowed = ({
    onClose,
    open,
}: Props) => {
    return (
        <ModalComponent
            open={open}
            titleProps={{
                fontSize: "2rem",
                fontWeight: 600
            }}
            description={<>
                No momento, não podemos atender à sua solicitação devido à sua situação junto ao SERASA.
                <br />
                <br />
                Estamos à disposição para ajudar assim que possível.
                <br />
                <br />
                Obrigado pela compreensão!
            </>}
            descriptionProps={{
                fontSize: "1.4rem",
                fontWeight: 400,
                sx: {
                    opacity: 1,
                    textAlign: "center"
                }
            }}
            showButtonClose={false}
        >
            <Button
                variant="contained"
                color="primary"
                sx={{ width: "100%", mt: "0rem" }}
                onClick={onClose}
            >
                SAIR
            </Button>
        </ModalComponent >
    );
};
